
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["eaeCenter_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1023.942 728.423c0 69.488-56.863 125.84-127.203 125.84-7.79 0-15.354-.967-22.746-2.275a475.493 475.493 0 01-366.144 171.898 473.787 473.787 0 01-365.52-171.102c-4.89.568-9.666 1.478-14.67 1.478C57.376 854.262.455 797.911.455 728.423c0-36.961 16.32-69.828 41.852-92.858a465.997 465.997 0 01-7.336-79.723c0-213.067 144.263-392.074 341.182-448.653A139.884 139.884 0 01512.398.058c67.44 0 123.849 47.31 137.155 110.258 191.744 59.764 331.116 236.155 331.116 445.526 0 24.793-2.502 49.244-6.425 73.354 30.023 23.03 49.698 58.684 49.698 99.227zM512.398 57.775c-45.207 0-81.997 36.392-81.997 81.144s36.79 81.201 81.997 81.201c45.206 0 81.997-36.45 81.997-81.201 0-44.752-36.79-81.144-81.997-81.144zm389.515 498.067c-.17-168.316-108.552-310.702-259.639-365.177a140.282 140.282 0 01-260.833-3.071c-155.351 52.2-267.657 196.748-267.657 368.248 0 16.32 2.9 31.787 4.834 47.538 3.07-.227 5.913-.91 9.098-.91 70.226 0 127.147 56.352 127.147 125.953 0 34.8-14.33 66.303-37.416 89.105A393.382 393.382 0 00507.849 945.87c117.935 0 222.507-52.314 294.723-133.572a124.19 124.19 0 01-32.98-83.874A126.578 126.578 0 01896.739 602.47l.34.057c1.934-15.467 4.777-30.706 4.777-46.685zM507.85 758.732c-113.273 0-205.05-90.812-205.05-202.89 0-112.02 91.777-202.946 205.05-202.946 113.215 0 204.993 90.925 204.993 202.946 0 112.078-91.778 202.89-204.993 202.89z"}})])
          )
        }
      }
    